//libs\components\modal\src\lib\modal.module.ts
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UiModalComponent } from './ui-modal/ui-modal.component';
import { UiModalChangeListComponent } from './ui-modal-change-list/ui-modal-change-list.component';
import { UiModalItemSummaryComponent } from './ui-modal-item-summary/ui-modal-item-summary.component';
import { ModalGlobalComponent } from './ui-modal-global/modal-global.component';
import { UiModalMascotComponent } from './ui-modal-mascot/ui-modal-mascot.component';
import { MascotModule } from '@cardapio-online/mascot';

@NgModule({
  imports: [CommonModule],
  declarations: [
    UiModalComponent,
    UiModalChangeListComponent,
    UiModalItemSummaryComponent,
    ModalGlobalComponent,
    UiModalMascotComponent,
  ],
  exports: [
    UiModalComponent,
    UiModalChangeListComponent,
    UiModalItemSummaryComponent,
    ModalGlobalComponent,
    UiModalMascotComponent,
  ],
})
export class ModalModule {}
